import React, { useCallback } from 'react';
import { AuthEmailSent } from 'shared-portal-component';
import { useNavigate } from '@tanstack/react-router';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '@/store';
import { selectForgotPasswordEmailAddress, selectAuthStatus } from '@/store/selectors/auth';
import { forgotPasswordThunk } from '@/store/thunks/auth/forgotPasswordThunk';

const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const emailAddress = useSelector(selectForgotPasswordEmailAddress);
  const authStatus = useSelector(selectAuthStatus);

  const handleProceed = () => {
    void navigate({ to: '/reset-password/otp-verify' });
  };

  const handleResend = useCallback(() => {
    if (emailAddress) {
      void dispatch(forgotPasswordThunk({ emailAddress }));
    }
  }, [dispatch, emailAddress]);

  return (
    <AuthEmailSent
      onProceed={handleProceed}
      onResend={handleResend}
      loading={authStatus === 'loading'}
    />
  );
};

export default ForgotPassword;
